import { Link } from '@loomhq/lens';
import React from 'react';

import { LOOM_URI } from 'constants/routes';

import styles from './styles.module.less';

export default function TagLink({ tag, ...linkProps }) {
  return (
    <Link
      variant="neutral"
      href={`${LOOM_URI}/tag/${tag}`}
      className={styles.tagLink}
      {...linkProps}
    >
      {`#${tag}`}
    </Link>
  );
}
